import type { FC } from "react";
import { routes } from "../../../routes";
import { AlertMessageCondition } from "../types";
import { AlertMessageLink } from "../../../../components/AlertMessage/AlertMessageLink";
import type { AlertMessageLinkWrapperProps } from "./types";

export const DefaultOneSavedPharmacyLink: FC<AlertMessageLinkWrapperProps> = ({
  children,
  ...props
}) => (
  <AlertMessageLink
    {...props}
    to={routes.managePharmacies}
    condition={AlertMessageCondition.OneSavedPharmacy}
  >
    {children}
  </AlertMessageLink>
);

export const OneSavedPharmacyLink: FC<AlertMessageLinkWrapperProps> = ({
  children,
  alertMessageContext,
  ...props
}) => {
  const hasPlan = !!alertMessageContext.planId;
  const inNetworkPharmacyFinderLink = routes.inNetworkPharmacy.replace(
    ":id",
    alertMessageContext?.planId || ""
  );
  const summaryPageAddPharmaciesLink = hasPlan
    ? inNetworkPharmacyFinderLink
    : routes.pharmacy;
  return (
    <AlertMessageLink
      {...props}
      condition={AlertMessageCondition.OneSavedPharmacy}
      to={`${
        alertMessageContext.isFromSummaryPage
          ? summaryPageAddPharmaciesLink
          : inNetworkPharmacyFinderLink
      }${alertMessageContext?.search || ""}`}
      state={alertMessageContext?.routerState}
    >
      {children}
    </AlertMessageLink>
  );
};
